import { dt } from "@resamare/functions";
import { useRef } from "react";
import { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import { ArrowLeftIcon, ArrowRightIcon, IconButton, Typography } from "../../../../General";
import { useMonthsChange } from "../../useMonthsChange";
import { MonthSpinner } from "../MonthSpinner/MonthSpinner";

import styles from "./Header.module.scss";

interface HeaderProps
    extends Pick<
        ReactDatePickerCustomHeaderProps,
        | "customHeaderCount"
        | "decreaseMonth"
        | "increaseMonth"
        | "monthDate"
        | "nextMonthButtonDisabled"
        | "prevMonthButtonDisabled"
    > {
    isMonthsLoading?: boolean[];
    locale: "fr" | "en";
    monthsShownLength: number;
    onMonthsChange?: (months: string[]) => void;
}

export function Header({
    customHeaderCount,
    decreaseMonth,
    increaseMonth,
    isMonthsLoading,
    locale,
    monthDate,
    monthsShownLength,
    nextMonthButtonDisabled,
    prevMonthButtonDisabled,
    onMonthsChange,
}: HeaderProps) {
    const headerRef = useRef<HTMLDivElement>(null);
    const firstHeader = customHeaderCount === 0;
    const lastHeader = customHeaderCount === monthsShownLength - 1;

    useMonthsChange(headerRef, (months) => onMonthsChange?.(months), [monthsShownLength]);

    return (
        <>
            {isMonthsLoading?.[customHeaderCount] ? <MonthSpinner /> : null}
            <div
                className={styles["header"]}
                data-month={dt.toIsoMonth(monthDate)}
                ref={firstHeader ? headerRef : null}
            >
                <div style={{ visibility: firstHeader ? "visible" : "hidden" }}>
                    <IconButton
                        aria-label="Previous month"
                        disabled={onMonthsChange ? false : prevMonthButtonDisabled}
                        onClick={decreaseMonth}
                    >
                        <ArrowLeftIcon />
                    </IconButton>
                </div>

                <Typography variant="label">
                    {monthDate.toLocaleDateString(locale, { month: "long", year: "numeric" })}
                </Typography>
                <div style={{ visibility: lastHeader ? "visible" : "hidden" }}>
                    <IconButton
                        aria-label="Next month"
                        disabled={onMonthsChange ? false : nextMonthButtonDisabled}
                        edge="start"
                        onClick={increaseMonth}
                    >
                        <ArrowRightIcon />
                    </IconButton>
                </div>
            </div>
        </>
    );
}
